import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21.061",
  height: "19.007",
  viewBox: "0 0 5.572 5.029"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.572 2.776a.83.83 0 0 0-.728-.858.49.49 0 0 0-.342-.333 1.721 1.721 0 0 0-3.432 0 .49.49 0 0 0-.342.333l-.042.005V.86a.163.163 0 1 0-.327 0v1.193a.88.88 0 0 0-.358.723.83.83 0 0 0 .727.857.49.49 0 0 0 .34.333.86.86 0 0 0 .847.715h.038a.51.51 0 0 0 .485.348h.696a.511.511 0 1 0 0-1.023h-.696a.51.51 0 0 0-.485.348h-.038a.534.534 0 0 1-.515-.397.49.49 0 0 0 .33-.463V2.058a.49.49 0 0 0-.332-.464 1.394 1.394 0 0 1 2.776 0 .49.49 0 0 0-.332.464v1.436a.49.49 0 0 0 .49.49h.043a.49.49 0 0 0 .47-.35.83.83 0 0 0 .727-.858zM2.438 4.332h.696a.185.185 0 0 1 0 .37h-.696a.185.185 0 1 1 0-.37M.327 2.776a.525.525 0 0 1 .38-.526v1.051a.525.525 0 0 1-.38-.525m1.077.718a.164.164 0 0 1-.163.163h-.043a.164.164 0 0 1-.164-.163V2.057a.164.164 0 0 1 .164-.163h.043a.164.164 0 0 1 .163.163zm3.134 0a.164.164 0 0 1-.163.163H4.33a.164.164 0 0 1-.163-.163V2.057a.164.164 0 0 1 .163-.163h.044a.163.163 0 0 1 .163.163zm.326-.193v-1.05a.553.553 0 0 1 0 1.05m0 0"
    }, null, -1)
  ])))
}
export default { render: render }